import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "@/hooks/useToast"

const useVideoCallPickupErrorListener = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== location.origin) return
      if (event.data?.action === "video-call-pickup-failed") {
        toast({ description: t("videoCall.partnerNoLongerInVideoCall") })
      }
    }
    window.addEventListener("message", handler)
    return () => window.removeEventListener("message", handler)
  }, [t])
}

export { useVideoCallPickupErrorListener }
